import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  deniedTalents: null,
  loading: false,
  total: 0,
  filters: [],
  filteredTotal: 0,
  sortableColumns: null,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters, sortableColumns } = payload;

  return {
    ...state,
    deniedTalents: data,
    total,
    filters,
    filteredTotal,
    sortableColumns,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
